// Dependencies
import React from 'react';
import uuid from 'react-uuid';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

// Components
import Container from '../../container/container';
import Image from '../../image/image';

// Hooks
import useLocationsPostTypeFilteredWithoutChildren from '../../../hooks/useLocationsPostTypeFilteredWithoutChildren';

// Styles
import LocationsMapStyles from './locationsMap.styles';

export default function LocationsMap({ layout }) {
  const locations = useLocationsPostTypeFilteredWithoutChildren();

  const heading = layout?.heading;
  const text = layout?.text;
  const img = layout?.image;

  return (
    <LocationsMapStyles>
      <Container>
        <h3 className="heading">{heading}</h3>

        {img && <Image image={img} className="img" />}

        <div className="text">{parse(text)}</div>

        <span className="separator" />

        <ul className="locations">
          {locations.map((location) => {
            let link = location?.locations?.externalLink || location?.uri;
            if (location?.locations?.linkToParent && location?.parentUri)
              link = location?.parentUri;

            const target = location?.locations?.externalLink
              ? '_blank'
              : '_self';

            return (
              <li key={uuid()} className="location">
                <Link
                  to={link}
                  className="btn location"
                  target={target}
                  title={`Matchmaking in ${location?.title}`}
                >
                  {location?.title}
                </Link>
              </li>
            );
          })}

          <li className="more">
            <p>and more...</p>
          </li>
        </ul>

        <span className="separator" />
      </Container>
    </LocationsMapStyles>
  );
}

LocationsMap.propTypes = {
  layout: PropTypes.shape({
    heading: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.shape({
      altText: PropTypes.string,
      gatsbyImage: PropTypes.shape({}),
    }),
  }),
};

LocationsMap.defaultProps = {
  layout: {},
};
